import { styleConfig } from "@chakra-ui/theme-tools";
/**
 * Variants Style
 */

function grayGhost() {
  return {
    color: "gray.600",
    _hover: {
      bg: "gray.200"
    },
    _active: {
      bg: "gray.300"
    }
  };
}

function ghost(props) {
  var c = props.colorScheme;
  if (c === "gray") return grayGhost(props);
  return {
    color: c + ".200",
    bg: "transparent",
    _hover: {
      bg: c + ".100"
    },
    _active: {
      bg: c + ".100",
      color: c + ".300"
    },
    _disabled: {
      color: "gray.500",
      background: "transparent",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  };
}

function outline(props) {
  return Object.assign({
    border: "1px solid",
    borderColor: "currentColor"
  }, ghost(props), {
    _disabled: {
      background: "transparent",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  });
}

function graySolid(props) {
  return {
    bg: "gray.300",
    color: "gray.700",
    _hover: {
      bg: "gray.600",
      color: "white"
    },
    _active: {
      bg: "gray.700",
      color: "white"
    },
    _disabled: {
      background: "gray.300",
      color: "gray.600",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  };
}

function solid(props) {
  var c = props.colorScheme;
  if (c === "gray") return graySolid(props);
  return {
    bg: c + ".200",
    color: "white",
    _hover: {
      bg: c + ".300"
    },
    _active: {
      bg: c + ".400"
    },
    _disabled: {
      background: "gray.300",
      color: "gray.600",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  };
}

function reverse(props) {
  var c = props.colorScheme;
  return Object.assign({}, solid(props), {
    bg: c + ".300",
    _hover: {
      bg: c + ".200"
    },
    _active: {
      bg: c + ".200"
    }
  });
}

function grayLink() {
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    color: "gray.700",
    _hover: {
      textDecoration: "underline"
    }
  };
}

function link(props) {
  var c = props.colorScheme;
  if (c === "gray") return grayLink(props);
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    color: c + ".200",
    _hover: {
      color: c + ".300",
      textDecoration: "underline"
    },
    _active: {
      color: c + ".400"
    },
    _disabled: {
      color: "gray.400"
    }
  };
}

var unstyled = {
  bg: "none",
  border: 0,
  color: "inherit",
  display: "inline",
  font: "inherit",
  lineHeight: "inherit",
  margin: 0,
  padding: 0
};
var button = styleConfig({
  baseStyle: {
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "bold",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      color: "gray.600",
      cursor: "not-allowed",
      boxShadow: "none"
    }
  },
  sizes: {
    lg: {
      height: "12",
      minWidth: "12",
      fontSize: "lg",
      paddingX: "4"
    },
    md: {
      height: "10",
      minWidth: "10",
      fontSize: "md",
      paddingX: "3"
    },
    sm: {
      height: "8",
      minWidth: "8",
      fontSize: "sm",
      paddingX: "2"
    },
    xs: {
      height: "6",
      minWidth: "6",
      fontSize: "xs",
      paddingX: "1"
    }
  },
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  },
  variants: {
    unstyled: unstyled,
    solid: solid,
    ghost: ghost,
    link: link,
    outline: outline,
    reverse: reverse
  }
});
export default button;